export const DEVICE_TYPES = ['iosOtherBrowser', 'iosSafari', 'androidOpera', 'androidFirefox']